import { defineComponent, h } from 'vue';
import { QToggle, QTooltip } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';
import DesignerRegistryMixin from './DesignerRegistryMixin.jsx';

const BASIC_TOGGLE_CHANGE_CODE_BEHIND = {
    handlerSuffix: '_Change',
    actionTypeSchema: '/schema/public/Platform.Schema.UIActions.v1/UIAction_Script',
    buildScopeMethodTemplate(methodName) {
        return `\t${methodName}(context) {\n\t\t// Place your change handler here\n\t}`;
    },
};

export default defineComponent({
    name: 'basic-toggle-dsgn',
    mixins: [DesignerRegistryMixin],
    components: { QToggle, QTooltip },
    data: function () {
        return {
        }
    },
    created() {
    },
    computed: {
        Root: function () {
            return this.root;
        },
        selected$: function () {
            return this.Root.SelectedNode && this.Root.SelectedModel == this.designmodel;
        },
        sizeStyle() {
            return utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent);
        },
        containerStyles() {
            let styles = {
                ...utils.resolveStyleHints(this.controlData.StyleHints, this),
                ...this.sizeStyle,
                //display: 'flex',
                //flexDirection: 'column',
                //alignItems: 'center'
            };
            return styles;
        },
        switchSize() {
            switch (this.controlData.SwitchSize ?? this.controlData.ToggleSize) {
                case 'tiny': return 'xs';
                case 'mini': return 'sm';
                case 'small': return 'md';
                case 'standard': return 'lg';
                case 'large': return 'xl';
                default:
                    return 'md';
            }
        },
    },
    methods: {
        ...methods,
        handleClick(e) {
            this.Root.SelectNode(this);
            e.cancelBubble = true;
            e.stopPropagation();
        },
        handleDesignerDblClick(e) {
            e.stopPropagation();
            e.preventDefault();
            this.Root?.openCodeBehind?.(this, BASIC_TOGGLE_CHANGE_CODE_BEHIND);
        },
    },
    props: {
        name: '',
        root: null,
        rowData: null,
        designmodel: null,
        parentType: '',
        controlData: {}
    },
    render() {
        let value = this.controlData.Default == 'true';

        let toggle = (
            <QToggle
                name={this.icon}
                label={value ? this.controlData.OnLabel : this.controlData.OffLabel}
                color={this.controlData.Color}
                size={this.switchSize}
                style={this.iconStyles}
                class={this.iconClasses}
                modelValue={value}
            >
                <QTooltip transition-show="scale" transition-hide="scale">
                    {utils.renderTooltipContent(this.controlData.Tooltip)}
                </QTooltip>
            </QToggle>
        );


        return (
            <div
                style={this.containerStyles}
                class={{ 'c-BasicSwitch': true, 'designer-container': true, selected: this.selected$ }}
                onClick={(e) => this.handleClick(e)}
                onDblclick={(e) => this.handleDesignerDblClick(e)}>
                <div class={{ "designer-container-hovering": true, 'designer-container-selected': this.selected$ }}></div>
                {toggle}
            </div>
        );
    }
});